import { AlertTriangle } from "lucide-react";

interface LowStockWarningProps {
  /** Real inventory count. Component renders nothing unless a verified value <= threshold is passed. */
  quantityAvailable?: number;
  threshold?: number;
}

/**
 * Honest low-stock indicator. Only renders when a real inventory count is provided
 * and falls at/under the threshold. No randomized or simulated urgency.
 */
export const LowStockWarning = ({ quantityAvailable, threshold = 5 }: LowStockWarningProps) => {
  if (typeof quantityAvailable !== "number" || quantityAvailable <= 0 || quantityAvailable > threshold) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 text-amber-700 bg-amber-50 px-3 py-2 text-[13px] font-medium">
      <AlertTriangle className="h-4 w-4 flex-shrink-0" />
      <span>Only {quantityAvailable} left in stock — order soon</span>
    </div>
  );
};
